import { memo } from "react"

const AssetIcon = memo<{
  assetIconUrl: string
  chainIconUrl?: string
  className?: string
  chainClassName?: string
  chainIconSize?: number
  iconSize: number
}>(({ assetIconUrl, chainIconUrl, className, chainClassName, chainIconSize, iconSize }) => {
  const chainIcon = chainIconUrl && assetIconUrl !== chainIconUrl && (
    <img alt="chain icon url" src={chainIconUrl} loading="lazy" className={`absolute bottom-0 left-0 ${chainClassName ? chainClassName : ""}`} height={chainIconSize} width={chainIconSize} />
  )
  return (
    <div className={`relative ${className ? className : ""}`}>
      <img alt="asset icon url" src={assetIconUrl} loading="lazy" height={iconSize} width={iconSize} />
      {chainIcon}
    </div>
  )
})

export default AssetIcon
